import { render, staticRenderFns } from "./CreateSubAcc.vue?vue&type=template&id=046fe7b2&scoped=true"
import script from "./CreateSubAcc.vue?vue&type=script&lang=ts"
export * from "./CreateSubAcc.vue?vue&type=script&lang=ts"
import style0 from "./CreateSubAcc.vue?vue&type=style&index=0&id=046fe7b2&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "046fe7b2",
  null
  
)

export default component.exports